// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

// import { css } from 'emotion';
import React from 'react';
import { navigate } from 'hookrouter';
import { unauth } from '../actions';
import { useDispatch } from 'react-redux'
const Logout = () => {


  const dispatch = useDispatch();
  dispatch(unauth())
  navigate('/route')

  return (
    <>
    </>
  );
}

export default Logout;